import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/Context";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import QuestionList from "../../components/Questions/QuestionList";

const Home = () => {
  const [userData] = useContext(UserContext);
  const [allQuestions, setAllQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

  const navigate = useNavigate();

  useEffect(() => {
    if (!userData?.user) {
      navigate("/login");
      return;
    }

    const fetchQuestions = async () => {
      setIsLoading(true);
      setErrorMessage("");

      try {
        const response = await axios.get(`${apiBaseUrl}/api/questions/all`, {
          headers: {
            "x-auth-token": localStorage.getItem("auth-token") || "",
          },
        });
        const questions = response?.data?.data || [];
        setAllQuestions(questions);
      } catch (error) {
        console.error("Failed to fetch questions:", error);
        setErrorMessage(
          "Unable to load questions right now. Please try again.",
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuestions();
  }, [userData, navigate, apiBaseUrl]);

  return (
    <>
      <div className="bg-gray-100 pt-4">
        <div className="bg-white">
          <div className="flex justify-between items-center pt-4 pe-16 ps-[100px]">
            <button
              onClick={() => navigate("/askquestion")}
              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-orange-400 ms-4 text-sm flex relative text-center "
            >
              Ask Question
            </button>
            <h4 className="text-xl font-medium">
              Welcome: {userData.user?.display_name}
            </h4>
          </div>

          <h3 className="text-xl font-medium ps-28 pt-4 ">Questions</h3>

          {isLoading ? (
            <p className="px-28 py-6 text-gray-500">Loading questions...</p>
          ) : errorMessage ? (
            <p className="px-28 py-6 text-red-600">{errorMessage}</p>
          ) : allQuestions.length === 0 ? (
            <p className="px-28 py-6 text-gray-500">
              No questions yet. Be the first to ask one.
            </p>
          ) : (
            <div className="mt-4 divide-y-4 divide-slate-400/[.24] divide-gray-800">
              {allQuestions.map((question) => (
                <div key={question.question_id} className="mb-4">
                  <Link
                    to={`/answer/${question.question_id}`}
                    state={{
                      question: question,
                      currentUserId: userData.user?.id,
                    }}
                    className="block"
                  >
                    <QuestionList question={question} />
                  </Link>
                </div>
              ))}
            </div>
          )}
          {allQuestions.length < 3 && <div className="mt-4" />}
        </div>
      </div>
    </>
  );
};

export default Home;
